<template>
  <div class="allerta-caricamenti">
    <div class="header-section">
      <h2 class="page-title">Statistiche Caricamenti</h2>
      <p class="subtitle">Monitoraggio nuovi punti di prelievo</p>
    </div>
    <Loader v-if="loading" />
    <div class="flex align-items-center">
      <div class="col-6 md:col-3" style="max-height: 90px;">
        <div class="col-12">Filtra per data caricamento</div>
        <div class="mb-0 flex justify-content-center">
          <Calendar ref="calendarRef" v-model="selectedDate" @today-click="onTodayClick()" :maxDate="maxDate" selectionMode="range" :manualInput="false" @update:modelValue="onChange('data')" dateFormat="dd/mm/yy" class="w-full" style="height: 45px" showButtonBar />
        </div>
      </div>
      <div class="col-6 md:col-3" style="max-height: 90px;">
        <div class="col-12">Filtra per tipologia fornitura</div>
        <div class="mb-0 flex justify-content-center">
          <Dropdown v-model="selectedType" :options="types" optionLabel="name" placeholder="Seleziona una tipologia fornitura" class="w-full" style="height: 45px" @update:modelValue="onChange('tipologia')"/>
        </div>
      </div>
      <div class="col-6 md:col-3" style="max-height: 90px;">
        <div class="col-12">Filtra per agenzia</div>
        <div class="mb-0 flex justify-content-center">
          <Dropdown v-model="selectedAgenzia" :options="agenzie" optionLabel="name" optionValue="id" placeholder="Seleziona un'agenzia" class="w-full" style="height: 45px" filter :showClear="true" @change="onChange()"/>
        </div>
      </div>
      <div class="flex align-items-end col-2" style="height: 90px;" v-if="(selectedDate.filter(date => date)).length > 1">
        <Button label="Cerca" icon="pi pi-search" style="height: 40px" @click="getData()"/>
      </div>
    </div>
    <div v-if="loaded" class="content-section">
      <div class="main-tabs">
        <!-- Tabs -->
        <div class="tab-buttons">
          <button v-for="(data, type) in items" :key="type" @click="selectMainTab(type)"
            :class="['tab-button', { active: activeMainTab === type }]">
            {{ type.toUpperCase() }}
            <span class="tab-count">{{ data.data.pps.qt }}</span>
          </button>
        </div>
        <div class="step-tree">
          <div class="step-node">
            <!-- Step Firma -->
              <div class="step-header">
                <h3 class="step-title">Firma</h3>
              </div>
              <div class="step-boxes">
                <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'firmati')">
                  <div class="box-number">{{ items[activeMainTab].data.firmati.qt }}</div>
                  <div class="box-title">Firmati</div>
                </div>
                <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'non_firmati')">
                  <div class="box-number">{{ items[activeMainTab].data.non_firmati.qt }}</div>
                  <div class="box-title">Non Firmati</div>
                </div>
              </div>
            <!-- Step Firma -->
            <!-- Step Annullati -->
              <div class="step-node step-bord">
                <div class="step-header">
                  <h3 class="step-title">Validi e annullati</h3>
                </div>
                <div class="step-boxes">
                  <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'validi')">
                    <div class="box-number">{{ items[activeMainTab].data.validi.qt }}</div>
                    <div class="box-title">Validi</div>
                  </div>
                  <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'annullati')">
                    <div class="box-number">{{ items[activeMainTab].data.annullati.qt }}</div>
                    <div class="box-title">Annullati</div>
                  </div>
                  <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'annullati_timoe_timg')">
                    <div class="box-number">{{ items[activeMainTab].data.annullati_timoe_timg.qt }}</div>
                    <div class="box-title">Annullati {{ items[activeMainTab].type_timoe_timg }}</div>
                  </div>
                </div>
                <!-- Step Precheck -->
                  <div class="step-node step-bord">
                    <div class="step-header">
                      <h3 class="step-title">Precheck</h3>
                    </div>
                    <div class="step-boxes">
                      <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'precheck_0')">
                        <div class="box-number">{{ items[activeMainTab].data.precheck_0.qt }}</div>
                        <div class="box-title">Da Eseguire</div>
                      </div>
                      <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'precheck_1')">
                        <div class="box-number">{{ items[activeMainTab].data.precheck_1.qt }}</div>
                        <div class="box-title">OK</div>
                      </div>
                      <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'precheck_2')">
                        <div class="box-number">{{ items[activeMainTab].data.precheck_2.qt }}</div>
                        <div class="box-title">KO (Precheck da gestire)</div>
                      </div>
                    </div>
                    <!-- Step IV (solo per EE)
                      <div v-if="activeMainTab === 'ee'" class="step-node step-bord">
                      </div>
                    Step IV (solo per EE) -->

                    <div class="step-header">
                      <h3 class="step-title">IV</h3>
                    </div>
                    <div class="step-boxes">
                      <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'no_iv')">
                        <div class="box-number">{{ items[activeMainTab].data.no_iv.qt }}</div>
                        <div class="box-title">Da Eseguire</div>
                      </div>
                      <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'iv')">
                        <div class="box-number">{{ items[activeMainTab].data.iv.qt }}</div>
                        <div class="box-title">Eseguito</div>
                      </div>
                    </div>
                    <!-- Step Validazione -->
                      <div class="step-node step-bord">
                        <div class="step-header">
                          <h3 class="step-title">Validazione</h3>
                        </div>
                        <div class="step-boxes">
                          <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'validati')">
                            <div class="box-number">{{ items[activeMainTab].data.validati.qt }}</div>
                            <div class="box-title">Validati</div>
                          </div>
                          <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'ko_documenti')">
                            <div class="box-number">{{ items[activeMainTab].data.ko_documenti.qt }}</div>
                            <div class="box-title">Ko documenti</div>
                          </div>
                          <div class="step-box dark-teal-box" @dblclick="viewDetails(items[activeMainTab], 'non_validati')">
                            <div class="box-number">{{ items[activeMainTab].data.non_validati.qt }}</div>
                            <div class="box-title">Non Validati</div>
                          </div>
                          <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'bloccati')">
                            <div class="box-number">{{ items[activeMainTab].data.bloccati.qt }}</div>
                            <div class="box-title">Bloccati</div>
                          </div>
                          <div class="step-box dark-teal-box" @dblclick="viewDetails(items[activeMainTab], 'standby')">
                            <div class="box-number">{{ items[activeMainTab].data.standby.qt }}</div>
                            <div class="box-title">StandBy</div>
                          </div>
                          <div class="step-box dark-teal-box" @dblclick="viewDetails(items[activeMainTab], 'admin')">
                            <div class="box-number">{{ items[activeMainTab].data.admin.qt }}</div>
                            <div class="box-title">Admin</div>
                          </div>
                        </div>
                        <!-- Step Switch -->
                          <div class="step-node step-bord">
                            <div class="step-header">
                              <h3 class="step-title">Switch</h3>
                            </div>
                            <div class="step-boxes">
                              <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'no_switch', true)">
                                <div class="box-number">{{ items[activeMainTab].data.no_switch.qt }}</div>
                                <div class="box-title">Pratiche da inviare</div>
                              </div>
                              <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'switch')">
                                <div class="box-number">{{ items[activeMainTab].data.switch.qt }}</div>
                                <div class="box-title">In Switch</div>
                              </div>
                            </div>
                            <div class="step-node step-bord">
                              <div class="step-header">
                                <h3 class="step-title">Nuove pose</h3>
                              </div>
                              <div class="step-boxes">
                                <div class="step-box blue-box" @dblclick="viewDetails(items[activeMainTab], 'nuove_pose')">
                                  <div class="box-number">{{ items[activeMainTab].data.nuove_pose.qt }}</div>
                                  <div class="box-title">Nuove pose contatore</div>
                                </div>
                              </div>
                            </div>
                            <!-- Step Stati Switch -->
                              <div class="step-node step-bord">
                                <div class="step-header">
                                  <h3 class="step-title">Stati Switch</h3>
                                </div>
                                <div class="step-boxes">
                                  <div class="step-box dark-teal-box" @dblclick="viewDetails(items[activeMainTab], 'switchabili')">
                                    <div class="box-number">{{ items[activeMainTab].data.switchabili.qt }}</div>
                                    <div class="box-title">Switchabili</div>
                                  </div>
                                  <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'in_attesa_accettazione')">
                                    <div class="box-number">{{ items[activeMainTab].data.in_attesa_accettazione.qt }}</div>
                                    <div class="box-title">In attesa dell'accettazione Switch</div>
                                  </div>
                                  <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'switchati')">
                                    <div class="box-number">{{ items[activeMainTab].data.switchati.qt }}</div>
                                    <div class="box-title">Switchati</div>
                                  </div>
                                  <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'annullati_temporanei_switch')">
                                    <div class="box-number">{{ items[activeMainTab].data.annullati_temporanei_switch.qt }}</div>
                                    <div class="box-title">Annullati Switch</div>
                                  </div>
                                  <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'annullati_temporanei_timoe_timg')">
                                    <div class="box-number">{{ items[activeMainTab].data.annullati_temporanei_timoe_timg.qt }}</div>
                                    <div class="box-title">Annullati {{ items[activeMainTab].type_timoe_timg }}</div>
                                  </div>
                                </div>
                                <!-- Step TIMOE -->
                                  <div class="step-node step-bord">
                                    <div class="step-header">
                                      <h3 class="step-title">{{ items[activeMainTab].type_timoe_timg[0].toUpperCase() }}{{ items[activeMainTab].type_timoe_timg.slice(1) }}</h3>
                                    </div>
                                    <div class="step-boxes">
                                      <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'no_timoe_timg')">
                                        <div class="box-number">{{ items[activeMainTab].data.no_timoe_timg.qt }}</div>
                                        <div class="box-title">Da Caricare</div>
                                      </div>
                                      <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'timoe_timg_1')">
                                        <div class="box-number">{{ items[activeMainTab].data.timoe_timg_1.qt }}</div>
                                        <div class="box-title">OK</div>
                                      </div>
                                      <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'timoe_timg_0')">
                                        <div class="box-number">{{ items[activeMainTab].data.timoe_timg_0.qt }}</div>
                                        <div class="box-title">KO</div>
                                      </div>
                                    </div>
        
                                    <!-- Step Risultati -->
                                      <div class="step-node step-bord">
                                        <div class="step-header">
                                          <h3 class="step-title">Risultati Finali</h3>
                                        </div>
                                        <div class="step-boxes">
                                          <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'caricati')">
                                            <div class="box-number">{{ items[activeMainTab].data.caricati.qt }}</div>
                                            <div class="box-title">Caricati</div>
                                          </div>
                                          <div class="step-box orange-box" @dblclick="viewDetails(items[activeMainTab], 'non_caricati')">
                                            <div class="box-number">{{ items[activeMainTab].data.non_caricati.qt }}</div>
                                            <div class="box-title">Non Caricati</div>
                                          </div>
                                          <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'annullati_temporanei')">
                                            <div class="box-number">{{ items[activeMainTab].data.annullati_temporanei.qt }}</div>
                                            <div class="box-title">Annullati</div>
                                          </div>
                                          <div class="step-box teal-box" @dblclick="viewDetails(items[activeMainTab], 'in_fornitura')">
                                            <div class="box-number">{{ items[activeMainTab].data.in_fornitura.qt }}</div>
                                            <div class="box-title">In Fornitura</div>
                                          </div>
                                          <div class="step-box red-box" @dblclick="viewDetails(items[activeMainTab], 'non_in_fornitura')">
                                            <div class="box-number">{{ items[activeMainTab].data.non_in_fornitura.qt }}</div>
                                            <div class="box-title">Non In Fornitura</div>
                                          </div>
                                        </div>
                                      </div>
                                    <!-- Step Risultati -->
                                  </div>
                                <!-- Step TIMOE -->
                              </div>
                            <!-- Step Stati Switch -->
                          </div>
                        <!-- Step Switch -->                  
                      </div>
                    <!-- Step Validazione -->
                  </div>
                <!-- Step Precheck -->
              </div>
            <!-- Step Annullati -->
          </div>
        </div>
      </div>
    </div>
    <Toast />
    <Dialog v-model:visible="viewDialogDetails" modal :style="{ width: '80%' }" @hide="details.reset()">
      <template #header><h3>{{ details.title }}</h3></template>
      <DataTable :value="details.data" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" >
        <Column v-for="col of details.column" :key="col.field" :field="col.field" :header="col.header"></Column>
      </DataTable>
    </Dialog>
  </div>
</template>
<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard';
import Loader from "@/components/Loader.vue";
export default {
  name: 'StatisticheCaricamenti',
  components: { Loader },
  setup() {
    const loading = ref(false);
    const loaded = ref(false);
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const selectedDate = ref([]);
    const items = ref({});
    const activeMainTab = ref('ee');
    const maxDate = ref(new Date());
    const expanded = ref({
      step2: true,
      step3: true,
      step4: true,
      step5: true,
      step6: true,
      step7: true,
      step8: true,
    });
    const viewDialogDetails = ref(false)
    const agenzie = ref([])
    const types = ref([
      {name:'Elettrico', value:'ee', device: 'pod'},
      {name:'Gas', value:'gas', device: 'pdr'},
      {name:'Tutti', value:null}
    ])
    const selectedType = ref();
    const details = ref({
      title: '',
      data: [],
      column: [],
      reset: () => {
        details.value.title = ''
        details.value.data = []
        details.value.column = [],
        viewDialogDetails.value = false
      }
    })
    const selectedAgenzia = ref(null)
    const toggleStep = (stepKey) => {
      expanded.value[stepKey] = !expanded.value[stepKey];
      if (!expanded.value[stepKey]) {
        const stepNumber = parseInt(stepKey.replace('step', ''));
        for (let i = stepNumber + 1; i <= 8; i++) {
          expanded.value[`step${i}`] = false;
        }
      }
    };
    const formatDate = (d) => {
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    const getData = async () => {
      let fd = new FormData();
      let range = []
      if (selectedDate.value) {
        selectedDate.value.forEach((data) => {
          let giorno = data.getDate()
          giorno = giorno.toString().padStart(2, '0')
          let mese = data.getMonth() + 1
          mese = mese.toString().padStart(2, '0')
          let anno = data.getFullYear()
          data = `${anno}-${mese}-${giorno}`
          range.push(data)
        })
      }
      fd.append('range', range);
      if (selectedAgenzia.value) {
        fd.append('agenzia', selectedAgenzia.value);
      }
      if (selectedType.value.value) {
        fd.append('type', selectedType.value.value);
      }      
      loading.value = true;
      try {
        const response = await service.getStatistiche(fd);
        items.value = response.items;
        loaded.value = true
      } catch (error) {
        console.error('Errore nel recupero delle statistiche:', error);
      } finally {
        loading.value = false;
      }
    };
    const initializeDateRange = () => {
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      selectedDate.value = [start, today];
    };
    const selectMainTab = (tab) => {
      activeMainTab.value = tab;
    };
    const onChange = (filtro = null) => {
      if (filtro == 'data' && selectedDate.value[1]) {
        self.refs.calendarRef.overlayVisible = false;
      }
      if (filtro == 'tipologia') {
        activeMainTab.value = selectedType.value.value ?? 'ee'
      }
      loaded.value = false
      items.value = {}
    };
    const onTodayClick = () => {
      initializeDateRange();
    };
    const getAgenzie = async () => {
      loading.value = true
      await service.getAgents()
      .then((res)=>{
        agenzie.value = res.items.filter(item => !item.id_parent)
      }).finally(()=>{
        loading.value = false
      })
    }
    onMounted(() => {
      selectedType.value = types.value[2]
      getAgenzie()
      //initializeDateRange()
      //getData()
    });
    const viewDetails = async (data, filtro, more = false) => {
      if (data.data[filtro].qt > 0) {
        details.value.reset()
        details.value.title = data.data[filtro].title.replace('_', '')
        details.value.title = details.value.title[0].toUpperCase() + details.value.title.slice(1)
        if (more && !(`loaded_${filtro}` in data.data[filtro])) {
          loading.value = true
          let request = {}
          let device = (types.value.find(type => type.value == activeMainTab.value)).device
          request.path = filtro
          request.type = activeMainTab.value          
          request.data = data.data[filtro].pp.map(el => {
            return {
              agente: el.agente,
              matrice_id: el.matrice_id,
              id: el.id,
              code: el[device]
            }
          })
          await service.getDetailsStatistiche(request)
          .then((res)=>{
            res.item.props.forEach(prop => {
              data.data[filtro].columns.push({'field': prop, 'header': prop[0].toUpperCase() + (prop.replace('_', ' ')).slice(1)})
              res.item.data.forEach((el, index) => {
                data.data[filtro].pp[index][prop] = el[prop]
              })
            })
            data.data[filtro][`loaded_${res.item.path}`] = true
            
          })
          .finally(()=>{
            loading.value = false
          })
        }
        details.value.data = Object.values(data.data[filtro].pp)
        details.value.column = data.data[filtro].columns
        viewDialogDetails.value = true
      }
    }
    const changeSelectedType = () => {
      loaded.value = false
      activeMainTab.value = selectedType.value.value ?? 'ee'
    }

    return {
      loading,
      loaded,
      selectedDate,
      items,
      activeMainTab,
      maxDate,
      selectMainTab,
      getData,
      toggleStep,
      onTodayClick,
      onChange,
      agenzie,
      selectedAgenzia,
      types,
      selectedType,
      viewDetails,
      details,
      viewDialogDetails,
      changeSelectedType
    };
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
.allerta-caricamenti {
  font-family: 'Montserrat', sans-serif;
  padding: 1.5rem;
}
.header-section {
  margin-bottom: 2rem;
}
.page-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.subtitle {
  color: #666;
  font-size: 1rem;
}
.content-section {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.main-tabs {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.tab-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  border-bottom: 3px solid #e0e0e0;
  padding-bottom: 1rem;
}
.tab-button {
  padding: 0.8rem 1.5rem;
  border: none;
  background: #f5f5f5;
  color: #666;
  border-radius: 8px 8px 0 0;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}
.tab-button:hover {
  background: #16a085;
  color: white;
  transform: translateY(-2px);
}
.tab-button.active {
  background: #2c3e50;
  color: white;
  border-bottom: 3px solid #16a085;
}
.tab-count {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 1.3rem;
  font-weight: 700;
}
.tab-button.active .tab-count {
  background: #16a085;
  color: white;
}
.step-tree {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.step-node {
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}
.step-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}
.step-header:hover {
  background: #f8f9fa;
}
.step-icon {
  font-size: 0.9rem;
  color: #16a085;
  min-width: 14px;
  transition: transform 0.3s ease;
}
.step-title {
  font-size: 1.1rem;
  color: #2c3e50;
  margin: 0;
  font-weight: 600;
}
.step-boxes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-bottom: 1rem;
}
.step-box.teal-box {
  order: 1;
}
.step-box.orange-box,
.step-box.red-box,
.step-box.dark-teal-box,
.step-box.blue-box {
  order: 2;
}
.step-box {
  flex: 1 1 200px;
  min-width: 180px;
  padding: 1rem;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
}
.step-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.box-number {
  font-size: 1.8rem;
  font-weight: 800;
  margin-bottom: 0.3rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.box-title {
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
}
.box-arrow {
  position: absolute;
  top: 50%;
  right: 0.8rem;
  transform: translateY(-50%);
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}
.step-box:hover .box-arrow {
  right: 0.5rem;
  color: white;
}
.teal-box {
  background: linear-gradient(135deg, #16a085 0%, #1abc9c 100%);
}
.dark-teal-box {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}
.orange-box {
  background: linear-gradient(135deg, #e67e22 0%, #f39c12 100%);
}
.red-box {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
}
.blue-box {
  background: linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%);
}
.step-bord {
  margin-left: 20px;
  border-left: 2px solid #989797 !important;
  padding-left: 15px;
}
@media (max-width: 768px) {
  .allerta-caricamenti {
    padding: 1rem;
  }
  .step-tree {
    padding: 1rem;
  }
  .step-boxes {
    flex-direction: column;
    gap: 0.5rem;
  }
  .step-box {
    min-width: 100%;
    padding: 0.8rem;
  }
  .box-number {
    font-size: 1.5rem;
  }
  .box-title {
    font-size: 0.8rem;
  }
  .tab-buttons {
    flex-direction: column;
  }
  .tab-button {
    border-radius: 8px;
    justify-content: center;
  }
}
</style>
